import React, { useState } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import PopUp from '../popUp';
import CustomText from '../customText/CustomText';
import theme from '../../constants/theme.style.js';
import { baseUrl } from '../../constants/baseUrl';
import ProfileAvatarBackground from '../profileAvatar/ProfileAvatarBackground';

const styles = StyleSheet.create({
  contact: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 12,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderColor: theme.GREY_MEDIUM_COLOR,
  },
  contactImageContainer: {
    width: 65,
    height: 65,
    borderRadius: 15,
    marginRight: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  contactImage: {
    height: 65,
    width: 65,
    borderRadius: 15,
    overflow: 'hidden',
  },
  contactName: {
    color: theme.GREY_MEDIUM_COLOR,
    fontSize: theme.FONT_SIZE_HEADLINE,
    fontWeight: theme.FONT_WEIGHT_BOLD,
    fontFamily: 'Nunito_Bold',
  },
  userName: {
    color: theme.GREY_MEDIUM_LIGHT_COLOR,
    fontSize: theme.FONT_SIZE_REGULAR,
  },
  friendFavorite: {
    width: 25,
    height: 25,
    marginRight: 10,
  },
  friendSelected: {
    backgroundColor: theme.GREEN_DARKER_COLOR,
    width: 20,
    height: 20,
    borderRadius: 50,
    position: 'absolute',
    right: 30,
  },
  addIcon: {
    width: 25,
    height: 25,
    marginLeft: 30,
  },
  relationStatusContainer: {
    position: 'absolute',
    right: 5,
  },
  relationStatus: {
    borderRadius: theme.BUTTON_BORDER_RADIUS,
    overflow: 'hidden',
    fontWeight: 'bold',
    padding: 12,
    fontSize: 12,
  },
  relationSendRequest: {
    backgroundColor: theme.GREEN_DARKER_COLOR,
    color: theme.GREEN_LIGHT_COLOR,
  },
  relationSentRequest: {
    color: theme.GREEN_DARKER_COLOR,
  },
  relationAcceptedRequest: {
    color: theme.GREY_DARKER_COLOR,
  },
  friendSettingsButton: {
    fontSize: 20,
    color: theme.GREY_DARKER_COLOR,
    paddingBottom: 25,
  },
});

export const FriendItem = ({
  onFriendChange,
  onFriendRequestSend,
  currentUser,
  onFriendsFetch,
  draft,
  friend,
  selectItem,
  addAsFriend,
  relationStatus,
  callbackRequestSent,
  requestSent,
  onFetch,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [friendRequestSent, setFriendRequestSent] = useState(false);

  function addContact() {
    callbackRequestSent(friend);
    onFriendRequestSend(friend.id, currentUser.user.id);
    setFriendRequestSent(true);
  }

  async function callbackModalDelete() {
    await onFetch({
      url: `${baseUrl}friendship/${currentUser.user.id}/${friend.id}`,
      method: 'DELETE',
    })
      .then((res) => {
        res.text();
        onFriendsFetch(currentUser.user.id);
        setModalVisible(false);
      })
      .catch(() => {
        // do nothing
      });
  }

  function callbackModalBack() {
    setModalVisible(false);
  }

  if (currentUser.user.id === friend.id) {
    return null;
  }
  if (selectItem) {
    const onChange = (addedFriend) => {
      onFriendChange(addedFriend);
    };
    return (
      <TouchableOpacity
        style={styles.contact}
        testID={`${friend.id}Contact`}
        onPress={() => onChange(friend)}
      >
        <View style={styles.contactImageContainer}>
          <ProfileAvatarBackground
            testID={`${friend.id}ContactImage`}
            style={styles.contactImage}
            avatar={friend.avatar}
          />
        </View>
        <View>
          <CustomText style={styles.contactName}>{friend.firstname}</CustomText>
          <CustomText style={[styles.contactName, styles.userName]}>@{friend.nickname}</CustomText>
        </View>
        {draft.friend.id === friend.id && <View testID="knoedl" style={styles.friendSelected} />}
      </TouchableOpacity>
    );
  }
  if (addAsFriend) {
    return (
      <View style={styles.contact} testID={`${friend.id}Contact`}>
        <View style={styles.contactImageContainer}>
          <ProfileAvatarBackground
            testID={`${friend.id}ContactImage`}
            style={styles.contactImage}
            avatar={friend.avatar}
          />
        </View>
        <View>
          <CustomText style={styles.contactName}>{friend.firstname}</CustomText>
          <CustomText style={[styles.contactName, styles.userName]}>@{friend.nickname}</CustomText>
        </View>
        <View style={styles.relationStatusContainer}>
          {!requestSent && !friendRequestSent && relationStatus === undefined && (
            <TouchableOpacity onPress={addContact}>
              <CustomText style={[styles.relationStatus, styles.relationSendRequest]}>
                Send Request
              </CustomText>
            </TouchableOpacity>
          )}
          {(requestSent || friendRequestSent || relationStatus === 'Requested') && (
            <CustomText style={[styles.relationStatus, styles.relationSentRequest]}>
              Request Sent
            </CustomText>
          )}
          {relationStatus === 'Accepted' && (
            <CustomText style={[styles.relationStatus, styles.relationAcceptedRequest]}>
              Friends
            </CustomText>
          )}
        </View>
      </View>
    );
  }
  return (
    <View style={styles.contact} testID="friend-item">
      <View style={styles.contactImageContainer}>
        <ProfileAvatarBackground
          testID={`${friend.id}ContactImage`}
          style={styles.contactImage}
          avatar={friend.avatar}
        />
      </View>
      <View>
        <CustomText style={styles.contactName}>{friend.firstname}</CustomText>
        <CustomText style={[styles.contactName, styles.userName]}>@{friend.nickname}</CustomText>
      </View>
      <View style={styles.relationStatusContainer}>
        <TouchableOpacity onPress={() => setModalVisible(true)}>
          <CustomText style={[styles.relationStatus, styles.friendSettingsButton]}>...</CustomText>
        </TouchableOpacity>
      </View>
      {modalVisible && (
        <PopUp
          description={friend.firstname}
          button1="Delete"
          callback1={callbackModalDelete}
          button2="Back"
          callback2={callbackModalBack}
          visability={modalVisible}
          leftColor="#A90000"
          leftBgColor="#D0000015"
          rightColor="#828282"
          rightBgColor="#F2F2F2"
        />
      )}
    </View>
  );
};
